import { render } from "./EditContratPage.vue?vue&type=template&id=9115621a&ts=true"
import script from "./EditContratPage.vue?vue&type=script&lang=ts"
export * from "./EditContratPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__